module.exports = __webpack_public_path__ + "static/media/icon-text.102db432.png";